import React, { Component } from "react";
import "../css/Equipment.css"; // 스타일링을 위한 CSS 파일을 import합니다.
import Navbar from "./Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "../hock/withRouter";
import Swal from "sweetalert2";
import Footer from "./Footer";
import * as common from "../common/common.js";
import {
  faChevronLeft,
  faChevronRight,
  faIndustry,
  faFileAlt,
  faChargingStation,
} from "@fortawesome/free-solid-svg-icons";
import PieChart from "./PieChart";
import Option from "./Option.js";

class Equipment extends Component {
  apiUrl = process.env.REACT_APP_API_URL;

  api = {
    findEqipment: this.apiUrl + "/equipment",
    auth: this.apiUrl + "/authentication",
    sumShotSu: 0,
  };

  intervalEuipment = "";
  intervalTime = "";
  intervalPeriod = "";

  state = {
    cards: [],
    loadingPercentage: 0,
    auth: false,
    currentTime: new Date(),
    currentStartDateRange: "",
    currentEndDateRange: "",
    recentHogiNm: "",
    recentWriter: "",
    loading: false,
    isOptionDialogOpen: false,
    period: true,
    playTime: true,
    nonTime: true,
    shotSu: true,
  };

  constructor() {
    super();
  }

  async componentDidMount() {
    let storedPeriod = JSON.parse(localStorage.getItem("period"));
    let storedPlayTime = JSON.parse(localStorage.getItem("playTime"));
    let storedNonTime = JSON.parse(localStorage.getItem("nonTime"));
    let storedShotSu = JSON.parse(localStorage.getItem("shotSu"));

    if (storedPeriod === null) {
      storedPeriod = true;
    }
    if (storedPlayTime === null) {
      storedPlayTime = true;
    }
    if (storedNonTime === null) {
      storedNonTime = true;
    }
    if (storedShotSu === null) {
      storedShotSu = true;
    }

    this.handle.authenticationCheck();
    this.handle.generateDateRange();
    this.startLoadingAnimation();
    await this.handle.findEquipment();
    this.setState(
      {
        loading: true,
        period: storedPeriod,
        playTime: storedPlayTime,
        nonTime: storedNonTime,
        shotSu: storedShotSu,
      },
      () => {
        // setInterval(this.handle.checkCurrentSite, 1000);
        this.intervalEuipment = setInterval(this.handle.findEquipment, 5000);
        this.intervalTime = setInterval(this.handle.updateTime, 1000);
        this.intervalPeriod = setInterval(this.handle.generateDateRange, 30000);
      }
    );
  }

  fnc = {
    // 날짜를 'yyyy-mm-dd hh:mm:ss' 형식으로 변환하는 함수
    formatDate: (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      let meridiem = "오전";

      // 오후 시간대인 경우
      if (hours >= 12) {
        meridiem = "오후";
        // 오후 시간대의 경우 12를 빼서 12시간 형식으로 변환
        if (hours > 12) {
          hours -= 12;
        }
      }

      hours = String(hours).padStart(2, "0");

      return `${year}-${month}-${day} ${meridiem} ${hours}:${minutes}:${seconds}`;
    },
  };

  callback = {
    clear: (param) => {
      clearInterval(param);
    },
  };

  componentWillUnmount() {
    clearInterval(this.intervalEuipment);
    clearInterval(this.intervalPeriod);
    clearInterval(this.intervalTime);
  }

  handle = {
    startIntervals: () => {
      // 이미 interval이 실행 중인지 확인
      if (!this.intervalEuipment) {
        this.intervalEuipment = setInterval(this.handle.findEquipment, 5000);
      }
      if (!this.intervalTime) {
        this.intervalTime = setInterval(this.handle.updateTime, 1000);
      }
      if (!this.intervalPeriod) {
        this.intervalPeriod = setInterval(this.handle.generateDateRange, 10000);
      }
    },

    stopIntervals: () => {
      console.log("stopIntervals");
      // 기존 interval을 중지
      console.log(this.intervalEquipment);
      if (this.intervalEquipment) {
        clearInterval(this.intervalEquipment);
        this.intervalEquipment = null;
      }
      if (this.intervalPeriod) {
        clearInterval(this.intervalPeriod);
        this.intervalPeriod = null;
      }
      if (this.intervalTime) {
        clearInterval(this.intervalTime);
        this.intervalTime = null;
      }
    },
    checkCurrentSite: () => {
      // 현재 브라우저 창이 가려진(hidden) 상태인지 확인
      const isHidden = document.hidden;

      // 현재 브라우저 창이 보이지 않으면 interval을 종료합니다.
      if (isHidden) {
        console.log("숨겨짐");
        this.handle.stopIntervals();
      } else {
        console.log("보임");
        this.handle.stopIntervals();
        this.handle.startIntervals();
      }
    },
    updateState: (state, value) => {
      this.setState({ [state]: value });
    },
    saveOption: () => {
      localStorage.setItem("period", JSON.stringify(this.state.period));
      localStorage.setItem("playTime", JSON.stringify(this.state.playTime));
      localStorage.setItem("nonTime", JSON.stringify(this.state.nonTime));
      localStorage.setItem("shotSu", JSON.stringify(this.state.shotSu));
      this.setState({ isOptionDialogOpen: false });
    },
    closeDialog: () => {
      this.setState({ isOptionDialogOpen: false });
    },
    updateParentState: (newState) => {
      this.setState({ isOptionDialogOpen: newState });
    },
    generateDateRange: () => {
      const today = new Date();
      const currentHour = today.getHours();

      // 새벽 0시부터 오전 8시까지는 전날 오전 8시가 startDate, 오늘 오전 8시가 endDate
      let startDate, endDate;

      if (currentHour >= 0 && currentHour < 8) {
        // 현재 시간이 0시부터 8시 사이인 경우
        startDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1, // 전날
          8,
          0,
          0
        );
        endDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          8,
          0,
          0
        );
      } else {
        // 그 외의 경우
        startDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          8,
          0,
          0
        );
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 1);
        endDate.setHours(8, 0, 0);
      }

      const formattedStartDate = this.fnc.formatDate(startDate);
      const formattedEndDate = this.fnc.formatDate(endDate);

      this.setState({
        currentStartDateRange: formattedStartDate,
        currentEndDateRange: formattedEndDate,
      });
    },
    updateTime: () => {
      this.setState({
        currentTime: new Date(),
      });
    },
    findEquipment: async () => {
      try {
        const response = await fetch(this.api.findEqipment, {
          method: "POST",
          credentials: "include", // 이 옵션을 추가
        });

        const data = await response.json();
        const hogiData = data.data;
        const recentData = hogiData.filter((obj) => obj.recent === "Y");
        const sumShotSu = hogiData[0].sumShotSu;

        if (!common.isEmpty(hogiData))
          this.setState({
            cards: hogiData,
          });

        if (!common.isEmpty(recentData)) {
          this.setState({
            recentHogiNm: recentData[0].recentNm,
            recentWriter: recentData[0].writer,
          });
        }

        if (
          sumShotSu != null &&
          sumShotSu != "undefiend" &&
          sumShotSu != undefined
        ) {
          this.setState({
            sumShotSu: sumShotSu,
          });
        }
      } catch (error) {
        console.log(error);
        clearInterval(this.intervalEuipment);
        clearInterval(this.intervalPeriod);
        clearInterval(this.intervalTime);

        Swal.fire({
          text: "서버 오류가 발생하였습니다.",
          icon: "error",
        }).then(() => {
          this.props.navigate("/", { replace: true });
        });
      }
    },
    authenticationCheck: async () => {
      try {
        //API 호출 등을 통해 로그인 여부 확인
        const response = await fetch(this.api.auth, {
          method: "GET",
          credentials: "include", // 이 옵션을 추가
        });

        const data = await response.json();

        // 임시로 로그인 여부를 true로 설정
        const isLoggedIn = data.code === "200" ? true : false;

        if (isLoggedIn) {
          this.setState({
            auth: true,
          });
          this.props.navigate("/equipment", { replace: true });
        } else {
          this.props.navigate("/", { replace: true });
        }
      } catch (error) {
        console.log(error);
        Swal.fire({
          text: "서버 오류가 발생하였습니다.",
          icon: "error",
        }).then(() => {
          this.props.navigate("/", { replace: true });
        });
      }
    },
  };

  startLoadingAnimation = () => {
    const interval = 1000; // 1초 간격
    const totalTime = 4000; // 총 로딩 시간 (5초)

    let currentTime = 0;

    const loadingInterval = setInterval(() => {
      currentTime += interval;

      // 계산된 로딩 퍼센티지를 state에 업데이트
      const loadingPercentage = (currentTime / totalTime) * 100;
      this.setState({ loadingPercentage });

      // 5초 동안 로딩이 완료되면 인터벌 종료
      if (currentTime >= totalTime) {
        clearInterval(loadingInterval);

        // 5초 후에 로딩 상태를 초기화하고 다시 애니메이션을 시작
        setTimeout(() => {
          this.setState({ loadingPercentage: 0 }, this.startLoadingAnimation);
        }, 1000);
      }
    }, interval);
  };

  render() {
    console.log(this.state.period);
    return (
      <div>
        {this.state.auth && this.state.loading ? (
          <div>
            <Navbar auth={this.state.auth} />
            <Option updateParentState={this.handle.updateParentState}></Option>
            <h3
              className="timer"
              style={{
                marginRight: "20px",
                marginTop: "20px",
                textAlign: "right",
              }}
            >
              {/* toLocaleTimeString의 반환 값을 문자열로 변환 */}
              {this.state.currentTime.toLocaleTimeString()}
            </h3>
            <div className="title-container">
              <h1>설비 가동 및 비가동 현황</h1>
              <p>실시간으로 모니터링합니다.</p>
              {this.state.period && (
                <div style={{ marginTop: "20px" }} className="period-container">
                  <div className="info-container">
                    <h3>
                      작업 시작시간 :{" "}
                      {this.state.currentStartDateRange.toLocaleString()}
                    </h3>
                    <h3>
                      작업 종료시간 :{" "}
                      {this.state.currentEndDateRange.toLocaleString()}
                    </h3>
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                width: "100%",
                background: "#e0e0e0",
                height: "20px",
                marginTop: "20px", // 여기에 margin-top 추가
              }}
            >
              <div
                style={{
                  width: `${this.state.loadingPercentage}%`,
                  height: "100%",
                  background: "#3498db",
                  transition: "width 1s ease-in-out",
                }}
              />
            </div>
            <div className="recent-title">
              <h3>
                {" "}
                <FontAwesomeIcon icon={faChevronLeft} /> 최근 가동 설비 :{" "}
                {this.state.recentHogiNm}{" "}
                {this.state.recentWriter == "API_TEST" ? (
                  <FontAwesomeIcon icon={faFileAlt} />
                ) : (
                  <FontAwesomeIcon icon={faChargingStation} />
                )}
                <FontAwesomeIcon icon={faChevronRight} />{" "}
              </h3>
              <h3>
                {" "}
                <FontAwesomeIcon icon={faChevronLeft} /> 총 SHOT 수 :{" "}
                {this.state.sumShotSu} <FontAwesomeIcon icon={faChevronRight} />{" "}
              </h3>
            </div>
            <div className="card-container">
              {this.state.cards.map((card) => (
                <div
                  key={card.hogi}
                  className={`card 
                  ${
                    card.recent === "Y" && card.status === "가동중"
                      ? "recent-card"
                      : card.status === "가동중"
                      ? "active"
                      : ""
                  }`}
                >
                  <h2>
                    <FontAwesomeIcon icon={faIndustry} /> {card.hogi}
                  </h2>
                  <div className="hogi-details">
                    {this.state.playTime && (
                      <h3>가동시간: {card.operationTime}</h3>
                    )}
                    {this.state.nonTime && (
                      <h3>비가동시간: {card.nonOperationTime}</h3>
                    )}
                    {this.state.shotSu && <h3>SHOT: {card.shotSu}</h3>}
                  </div>
                  <h4 className="status">
                    {card.status} &nbsp;
                    {card.status === "가동중" && (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    )}
                  </h4>
                </div>
              ))}
            </div>
            <Footer></Footer>
            {this.state.isOptionDialogOpen && (
              <div className="modal-bg">
                <div className="dialog">
                  <h2>옵션 설정</h2>
                  <div className="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.period}
                        onChange={() =>
                          this.handle.updateState("period", !this.state.period)
                        }
                      />
                      작업기간
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.playTime}
                        onChange={() =>
                          this.handle.updateState(
                            "playTime",
                            !this.state.playTime
                          )
                        }
                      />
                      가동시간
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.nonTime}
                        onChange={() =>
                          this.handle.updateState(
                            "nonTime",
                            !this.state.nonTime
                          )
                        }
                      />
                      비가동시간
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.shotSu}
                        onChange={() =>
                          this.handle.updateState("shotSu", !this.state.shotSu)
                        }
                      />
                      SHOT
                    </label>
                  </div>
                  <div className="button-container">
                    <button
                      className="cancel-btn"
                      onClick={this.handle.closeDialog}
                    >
                      취소
                    </button>
                    <button
                      style={{ marginLeft: "15px" }}
                      className="confirm-btn"
                      onClick={this.handle.saveOption}
                    >
                      확인
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Equipment);
